const THOUSANDS_REGEXP = /(\d)(?=(\d{3})+(?!\d))/g;

export function formatPrice(price: number) {
    const formattedPrice = price
        .toFixed(0)
        .replace(THOUSANDS_REGEXP, '$1.');

    return `$${ formattedPrice }`;
}
